import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const STORAGE_KEY = "ezipper-identity";

const IdentityContext = createContext({
  me: null,
  identify: async () => {},
  logout: () => {},
});

export function IdentityProvider({ children }) {
  const [me, setMe] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (err) {
      console.warn("Identity: nu am putut citi din localStorage", err);
      return null;
    }
  });

  useEffect(() => {
    // Attach interceptor so /skills writes carry identity header.
    const interceptor = axios.interceptors.request.use((config) => {
      if (me && me.id) {
        config.headers = config.headers || {};
        config.headers["X-As-Employee"] = String(me.id);
      }
      return config;
    });
    return () => axios.interceptors.request.eject(interceptor);
  }, [me]);

  const identify = useCallback(async (email) => {
    const r = await axios.post(`${API}/auth/identify`, { email });
    const emp = r.data.employee;
    setMe(emp);
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(emp)); } catch (err) { console.warn("Identity: salvare eșuată", err); }
    return emp;
  }, []);

  const logout = useCallback(() => {
    setMe(null);
    try { localStorage.removeItem(STORAGE_KEY); } catch (err) { console.warn("Identity: logout localStorage eșuat", err); }
  }, []);

  return (
    <IdentityContext.Provider value={{ me, identify, logout }}>
      {children}
    </IdentityContext.Provider>
  );
}

export function useIdentity() {
  return useContext(IdentityContext);
}
